
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/client-servicing-resources",
      function () {
        return require("private-next-pages/resources/client-servicing-resources/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/client-servicing-resources"])
      });
    }
  